<template>
  <div class="tos">
    <!-- <TosD v-if="this.$store.state.device == 'desktop'" />
    <TosM v-else /> -->
    <TosM />
  </div>
</template>

<script>
// import TosD from '../components/desktop/Tos.vue'
import TosM from '../components/mobile/Tos.vue'

export default {
  name: 'tos',

  components: {
    // TosD,
    TosM
  },

  props: {
    type: String
  },

  data () {
    return {
    }
  },

  beforeMount () {
  },

  beforeDestroy () {
  },

  methods: {
  }
}
</script>

<style lang="stylus">

</style>



// WEBPACK FOOTER //
// TosView.vue